var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Header',{attrs:{"active":_vm.$route.params.id ? '' : 'recipes'}}),_c('v-container',{attrs:{"id":"main"}},[(!_vm.error)?_c('p',[_vm._v(_vm._s(_vm.$t("add-shared-success")))]):_c('p',[_vm._v(_vm._s(_vm.$t("add-shared-error")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }